
import { BadgeCheck, HandCoins } from "lucide-react";
import { AspectRatio } from "@/components/ui/aspect-ratio";

const BenefitsSection = () => {
  const benefits = [
    {
      text: "Amplia suas possibilidades de negócio e favorece o aumento do ticket médio de vendas",
      icon: BadgeCheck
    },
    {
      text: "O cliente pode pagar em até 24x no Crédito Direto ao Consumidor (CDC), sem sua clínica precisar emitir boletos e aceitar pagamentos em cheque",
      icon: BadgeCheck
    },
    {
      text: "Sua clínica recebe mais clientes através das indicações vindas da Dr.Cash",
      icon: BadgeCheck
    },
    {
      text: "Processo simples e fácil – 100% on-line",
      icon: BadgeCheck
    },
    {
      text: "Viabiliza um procedimento para seu paciente, que ele não poderia fazer sem crédito",
      icon: BadgeCheck
    },
    {
      text: "Antecipação de recebíveis disponível para maior flexibilidade financeira",
      icon: HandCoins
    }
  ];

  return (
    <section className="section-padding bg-gray-50">
      <div className="container mx-auto px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <h2 className="text-3xl md:text-4xl font-bold text-drcash-maastricht-blue mb-8">
              Por que a Dr.Cash é o melhor parceiro, em todos os momentos?
            </h2>

            <div className="space-y-6">
              {benefits.map((benefit, index) => (
                <div key={index} className="flex gap-4">
                  <benefit.icon className="w-6 h-6 text-drcash-caribbean-green flex-shrink-0 mt-1" />
                  <p className="text-gray-600">{benefit.text}</p>
                </div>
              ))}
            </div>
          </div>

          <div className="relative">
            <AspectRatio ratio={4/3} className="bg-white rounded-lg overflow-hidden">
              <img
                src="https://drcash.com.br/wp-content/uploads/2024/01/img-about3.png"
                alt="Dr.Cash Partnership Benefits"
                className="object-cover w-full h-full"
              />
            </AspectRatio>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BenefitsSection;
